export default "__VITE_ASSET__8dc380d1__"